import React, { useEffect } from "react";
import styled from "styled-components";
import { Modal, Dropdown, Form } from "antd";
import { Formik } from "formik";
import ButtonWrapper from "./ButtonWrapper";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction, {
  postCnyCreateTransaction,
  postIdrCreateTransaction,
} from "../redux/actions/postQrInitManual";
import { useNavigate, useParams } from "react-router-dom";
import { language } from "../utils/language";
const StyledWrapper = styled(Modal)`
  .ant-modal-close-x {
    display: none;
  }
  .ant-modal-body {
    padding: 20px 20px 20px 30px;
    p {
      font-size: 13px;
      font-weight: 600;
    }
  }
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 10px;
  }
  .warning-text {
    font-size: 25px !important;
    font-weight: bold;
    color: red;
  }
`;

const CnyWarningModal = (props) => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const params = useParams();

  const warningModalState = useSelector((state) => state.warningModalReducer);
  const { data, modalShow } = warningModalState;

  const qrInitManualState = useSelector(
    (state) => state.postQrInitManualReducer
  );
  const { error, isLoading } = qrInitManualState;

  const acceptWarningHandle = () => {
    dispatch(postCnyCreateTransaction(data, navigation, params.id));
  };

  return (
    <StyledWrapper {...props}>
      <div className="w-100 d-flex justify-content-center align-items-center flex-column">
        <p className="text-center">
          点击“下一步”即表示您同意提交的信息正确无误。
        </p>
        <p className="text-center">使用他人的信息可能会导致您的账户被暂停。</p>
        <p className="text-center mb-0">请仅使用您合法注册的信息。</p>
        <ButtonWrapper
          border={true}
          size="middle"
          bgColor="#003363"
          color="#fff"
          htmlType="submit"
          className="w-50 mt-4"
          text={"下一步"}
          loading={isLoading}
          type="primary"
          onClick={acceptWarningHandle}
        />
      </div>
    </StyledWrapper>
  );
};

export default CnyWarningModal;
